import React, { useState } from 'react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

import { Swiper, SwiperSlide } from 'swiper/react';
import type { Swiper as SwiperClass } from 'swiper/types';

import { EffectCoverflow, Pagination, Autoplay } from 'swiper/modules';
import { RootState } from '../store/rootReducers';
import { useSelector } from 'react-redux';

const images = [
  'https://picsum.photos/id/1018/600/400',
  'https://picsum.photos/id/1015/600/400',
  'https://picsum.photos/id/1019/600/400',
  'https://picsum.photos/id/1015/600/400',
  'https://picsum.photos/id/1019/600/400',
];

const CoverflowCarousel: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const banners = useSelector((state: RootState) => state.dashboard.banners);
  
  // Use banners if available, otherwise fallback to static images
  const carouselImages = banners && banners.length > 0 ? banners : images;

  return (
    <div style={{ width: '100%', margin: 'auto', textAlign: 'center', minHeight: '50px'}}>
      <Swiper
        effect="coverflow"
        grabCursor={true}
        centeredSlides={true}
        slidesPerView="auto"
        loop={true}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
        pagination={{ clickable: true }}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        onSlideChange={(swiper: SwiperClass) => setCurrentSlide(swiper.realIndex)}
        modules={[EffectCoverflow, Pagination, Autoplay]}
        className="mySwiper"
      >
        {carouselImages.map((img, index) => (
          <SwiperSlide key={index} style={{ width: '100%', height: '200px' }}>
            <img
              src={typeof img === 'string' ? img : img?.file?.fileURL}
              alt={`Slide ${index}`}
              style={{
                // display: 'block',
                width: '100%',
                height: '100%',
                // borderRadius: '12px',
                objectFit: 'cover',
                objectPosition: 'center',
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>

    
    </div>
  );
};

export default CoverflowCarousel;
